<template>
  <div class="about text-white mb-80 leading-loose tracking-normal">
    <div>
      <p class="text-center text-2xl ml-4">
        Buy and Sell NFTs directly with ETH
      </p>
    </div>
    <div
      class="mt-10 flex md:flex-row flex-col justify-center md:justify-between items-center md:space-x-24"
    >
      <div
        class="text-center md:text-left w-full md:w-full flex justify-center items-center flex-col space-y-12"
      >
        <!-- <div
          class="w-full flex justify-end space-x-4 items-center"
          @click="toggleSwapBtn"
        >
          <h2 class="text-white">toggle to swap NFT to NFT</h2>
          <div
            class="w-16 h-10 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out"
            :class="{ 'bg-green-400': toggleSwap }"
          >
            <div
              class="bg-white w-8 h-8 rounded-full shadow-md transform duration-300 ease-in-out"
              :class="{ 'translate-x-6': toggleSwap }"
            ></div>
          </div>
        </div> -->
        <div class="w-5/6 md:w-3/6">
          <InputAsset
            :action="'deposit'"
            :isSwap="toggleSwap"
            :isPrimary="isPrimary"
          />
        </div>
        <div class="flex">
          <svg
            @click="swapOpposite"
            class="cursor-pointer h-6 transform rotate-180"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 12.814 18.081"
          >
            <path
              fill="#ffffff"
              d="M0.146,12.027c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l5.054,5.054V0.5 c0-0.277,0.223-0.5,0.5-0.5s0.5,0.223,0.5,0.5v15.874l5.054-5.054c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707 l-5.906,5.907c-0.046,0.046-0.103,0.083-0.163,0.107c-0.062,0.025-0.126,0.039-0.191,0.039c-0.064,0-0.13-0.014-0.19-0.039 C6.154,18.018,6.1,17.98,6.054,17.935L0.146,12.027"
            />
          </svg>
          <svg
            @click="swapOpposite"
            class="cursor-pointer h-6"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 12.814 18.081"
          >
            <path
              fill="#ffffff"
              d="M0.146,12.027c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l5.054,5.054V0.5 c0-0.277,0.223-0.5,0.5-0.5s0.5,0.223,0.5,0.5v15.874l5.054-5.054c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707 l-5.906,5.907c-0.046,0.046-0.103,0.083-0.163,0.107c-0.062,0.025-0.126,0.039-0.191,0.039c-0.064,0-0.13-0.014-0.19-0.039 C6.154,18.018,6.1,17.98,6.054,17.935L0.146,12.027"
            />
          </svg>
        </div>

        <div class="w-5/6 md:w-3/6">
          <InputAsset
            :action="'withdraw'"
            :isSwap="toggleSwap"
            :isPrimary="!isPrimary"
          />
        </div>
        <div class="w-5/6 md:w-3/6">
          <button
            @click="swap"
            target="_blank"
            class="w-full text-center uppercase font-primary font-bold leading-none text-xl inline-block py-8 rounded-xl px-5 text-brown hover:text-white bg-secondary hover:bg-blue-400 hover:bg-opacity-70 transition duration-0 focus:outline-none"
          >
            SWAP
          </button>
        </div>
      </div>
    </div>

    <div
      class="text-center text-black mt-24 bg-white rounded-lg tracking-normal leading-6 p-8 space-y-8 mx-8"
    >
      <div class="text-xl font-bold">DISCLAIMER:</div>
      <div class="">
        Under the hood we use
        <a
          href="https://twitter.com/vasa_develop/status/1359845910818086914"
          class="text-black font-bold hover:underline"
          target="_blank"
          >Vasa's Cross Asset Swap</a
        >
        contract to market buy/sell NFT20s generated $TOKEN20 on Uniswap and
        redeem/deposit NFTs in our platform. The final price of the TX might
        cost a bit less than quoted and you'll get the change in ETH.
      </div>
      <div class="font-bold">This is in BETA so use with caution</div>
    </div>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";

import Web3EthAbi from "web3-eth-abi";

import InputAsset from "@/components/cas/InputAsset";
export default {
  name: "Cas",
  components: { InputAsset },
  data: function () {
    return {
      // score: 0,
      toggleSwap: false,
      isPrimary: true,
    };
  },
  beforeMount: async function () {},
  methods: {
    swapOpposite: async function () {
      this.$store.commit("setCasDeposit", {});
      this.$store.commit("setCasWithdraw", {});
      this.$store.commit("setCasPrice", 0);

      if (!this.toggleSwap) {
        this.isPrimary = !this.isPrimary;
        // alert("clicked");
      }
    },
    swap: async function () {
      const amount = new BigNumber(this.$store.state.casPrice)
        .shiftedBy(-parseInt(18))
        .toFixed(2, 1);

      console.log(this.$store.state.tokenSelected);
      console.log("deposit cas ", this.$store.state.casDeposit);
      console.log("withdraw cas ", this.$store.state.casWithdraw);

      if (
        !this.$store.state.casDeposit.nfts &&
        !this.$store.state.casWithdraw.nfts
      ) {
        alert("Pick the NFT to sell or to buy");
      }
      // from methods is nft
      if (this.$store.state.casDeposit) {
        let contract = null;
        if (this.$store.state.casDeposit.schema == 721) {
          contract = await this.$store.state.ERC721(
            this.$store.state.casDeposit.nft_address
          );
        } else if (this.$store.state.casDeposit.schema == 1155) {
          contract = await this.$store.state.ERC1155(
            this.$store.state.casDeposit.nft_address
          );
        }

        const data = Web3EthAbi.encodeParameters(
          ["address[]", "uint256[]", "uint256[]"],
          [
            [
              "0x0000000000000000000000000000000000000000",
              "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE", //dai
            ],
            [0],
            [0],
          ]
        );

        console.log(data);

        if (
          !confirm(
            `You are about to exchange NFT ID ${this.$store.state.casDeposit.nfts.ids[0]} for roughly ${amount} ETH`
          )
        ) {
          return;
        }
        console.log(this.$store.state.casDeposit.nfts.ids);
        console.log(this.$store.state.casDeposit.nfts.qty);
        console.log(this.$store.state.contracts.NFT20Swapper);

        if (this.$store.state.casDeposit.schema == 721) {
          let minetx = await contract.methods
            .safeTransferFrom(
              this.$store.state.account,
              this.$store.state.contracts.NFT20Swapper,
              this.$store.state.casDeposit.nfts.ids[0],
              data
            )
            .send({
              from: this.$store.state.account,
            });
        } else if (this.$store.state.casDeposit.schema == 1155) {
          let minetx = await contract.methods
            .safeBatchTransferFrom(
              this.$store.state.account,
              this.$store.state.contracts.NFT20Swapper,
              this.$store.state.casDeposit.nfts.ids,
              this.$store.state.casDeposit.nfts.qty,
              data
            )
            .send({
              from: this.$store.state.account,
            });
        }
      } else if (this.$store.state.casWithdraw) {
        if (
          !confirm(
            `You are about to exchange roughly ${amount} ETH for a NFT ID ${this.$store.state.casWithdraw.nfts.ids[0]}`
          )
        ) {
          return;
        }
        // params for call
        const toNft = this.$store.state.casWithdraw.nft_address;
        const ids = this.$store.state.casWithdraw.nfts.ids;
        const ammts = this.$store.state.casWithdraw.nfts.qty;
        // const changeIn = "0x6b175474e89094c44da98b954eedeac495271d0f"; //dai
        const changeIn = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"; //eth
        const price = this.$store.state.casPrice;

        console.log("tonft ", toNft);

        console.log("ids ", ids);

        console.log("price ", price);
        console.log("schema ", this.$store.state.casWithdraw.schema);

        if (this.$store.state.casWithdraw.schema == 721) {
          const tx = await this.$store.state.CasContract.methods
            .swapEthForERC721(toNft, ids, changeIn)
            .send({
              from: this.$store.state.account,
              value: price,
            });
        } else if (this.$store.state.casWithdraw.schema == 1155) {
          const tx = await this.$store.state.CasContract.methods
            .swapEthForERC1155(toNft, ids, ammts, changeIn)
            .send({
              from: this.$store.state.account,
              value: price,
            });
        }
      }
    },
    getPriceFromUniswap: async function () {
      // const price = await axios.get(``);
    },
    toggleSwapBtn: async function () {
      this.toggleSwap = !this.toggleSwap;
      if (this.toggleSwap) {
        // this.mainAsset = true;
      }
    },
    //   this.$store.commit("casIn", []);
  },
  computed: {},
  mounted: async function () {},
};
</script>


<style scoped>
p {
  padding: 0.6rem 0rem;
}

/* video {
  -moz-box-shadow: 0 -22px 22px -22px rgba(0, 0, 0, 0.8) inset;
  -webkit-box-shadow: 0 -22px 22px -22px rgba(0, 0, 0, 0.8) inset;
  box-shadow: 0 -100px 100px -100px rgba(0, 0, 0, 0.8) inset;
} */
</style>